import URL from 'url-parse';
import "../util/explorer_support";

let defaultServletPath = "/kirmizikurumsal";

let url = new URL(window.location.href);
let servletPath = "";

if (url.port === "3000" || url.pathname.startsWith(defaultServletPath))
    servletPath = defaultServletPath;

let reactPath;
if (url.pathname.startsWith(defaultServletPath))
    reactPath = defaultServletPath;
else
    reactPath = "/";

export const REACT_PATH = reactPath;
export const SERVLET_PATH = servletPath;
export const API_BASE_URL = servletPath + "/api";
export const ACCESS_TOKEN = 'accessToken';
export let VirtualHost = {
    resourcePrefix: "",
    companyName: "",
    companyLogo1: "",
    companyLogo2: "",
    companyAddress: "",
    companyCity: "",
    companyCitySubdivision: "",
    companyAddressName: "",
    companyTelephone: "",
    companyMapLocation: "",
    companyFacebookAddress: "",
    companyInstagramAddress: "",
    companyTwitterAddress: "",
    campaignMails: "",
    cardMails: "",
    checkUserRegister: false,
    companyLoginLogo: ""
};

export const PASSWORD_REGEX = /^(?=.*[!@#$%^&*.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const PASSWORD_ERROR_MESSAGE = "Şifreniz en az bir büyük, bir küçük ve bir özel karakter(!,@,#,$,%,^,&,*,.) içermelidir.";


// WEBPACK FOOTER //
// ./src/constants/index.js